<template>
  <div class="v-pano">
    <click-and-drag :show="showTutorial"/>
  </div>
</template>

<script>
import { ImagePanorama, VideoPanorama, Viewer } from 'panolens'
const _log = console.log.bind(console)

export default {
  name: 'Pano',

  props: {
    source: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'image'
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    pan: {
      type: Number,
      default: -1
    },
    horizontalView: {
      type: Boolean,
      default: false
    },
    autoRotate: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    showTutorial() {
      return this.$mq === 'lg'
    }
  },

  data () {
    return {
      size: {
        width: this.width,
        height: this.height
      },
      viewer: null,
      panorama: null,
    }
  },

  created () {
    window.addEventListener('resize', this.onResize, false)
  },

  destroyed () {
    if (this.panorama && this.panorama.dispose) {
      this.panorama.dispose()
    }
  },

  mounted () {
    if (this.width === undefined || this.height === undefined) {
      this.size = {
        width: this.$el.offsetWidth,
        height: this.$el.offsetHeight
      }
    }

    this.viewer = new Viewer({
      container: this.$el,
      cameraFov: 50,
      controlBar: this.type == 'video',
      horizontalView: this.horizontalView,
      autoRotate: this.autoRotate,
      autoRotateSpeed: 0.25,
    })

    this.loadPano()
  },
  watch: {
    source () {
      if (!this.viewer) return
      if (!this.panorama) return
      this.loadPano()
    }
  },

  methods: {
    onResize () {
      if (this.width === undefined || this.height === undefined) {
        this.$nextTick(() => {
          this.size = {
            width: this.$el.offsetWidth,
            height: this.$el.offsetHeight
          }
        })
      }
    },
    loadPano () {
      // _log('this.source = ' + this.source)
      if (!this.source) return

      let pano
      switch (this.type) {
        // case 'cube':
        //   var l = this.source.replace('%s', 'l')
        //   var f = this.source.replace('%s', 'f')
        //   var r = this.source.replace('%s', 'r')
        //   var b = this.source.replace('%s', 'b')
        //   var u = this.source.replace('%s', 'u')
        //   var d = this.source.replace('%s', 'd')
        //   pano = new PANOLENS.CubePanorama([r, l, u, d, f, b])
        //   break
        case 'video':
          pano = new VideoPanorama(this.source, { autoplay: true })
          break
        default:
          pano = new ImagePanorama(this.source)
          break
      }
      this.setPano(pano, this.pan)
    },
    setPano (pano, pan = -1) {
      if (!pano) return
      if (this.panorama) {
        this.viewer.remove(this.panorama)
      }
      this.panorama = pano
      this.viewer.add(this.panorama)
      this.viewer.setPanorama(this.panorama)

      // more settings
      this.viewer.getControl().panLeft(pan) // set inital pan
      this.viewer.OrbitControls.noZoom = true // disable zoom

      const that = this
      this.panorama.addEventListener('load', () => {
        that.$emit('on-load')
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../sass/variables';

.v-pano {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  border: 0;

  > div:last-child {
    > span:last-child {
      > span:last-child {
        width: 60% !important;

        @media ($md) {
          width: 90% !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/motor-show/Pano.vue